import React from 'react';
import PasswordlessLoginScreen from '../../src/screens/auth/PasswordlessLoginScreen';
import { useAuth } from '../../src/context/AuthContext';

export default function LoginRoute() {
  const { refreshAuth } = useAuth();
  return <PasswordlessLoginScreen onLoginSuccess={refreshAuth} />;
}
